import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SchoolType } from "../types";

export interface Gallery {
  id: string;
  title: string;
  image: string;
  school: SchoolType;
}

interface GalleryState {
  all: Gallery[];
  lyceeFrancais: Gallery[];
  lyceeIvoirien: Gallery[];
  institut: Gallery[];
  maternellePrimaire: Gallery[];
}

const initialState: GalleryState = {
  all: [],
  lyceeFrancais: [],
  lyceeIvoirien: [],
  institut: [],
  maternellePrimaire: []
};

export const gallerySlice = createSlice({
  name: "galleries",
  initialState,
  reducers: {
    setAllGalleries(state, action: PayloadAction<Gallery[]>) {
      state.all = action.payload;
    },
    setGalleriesBySchool(
      state,
      action: PayloadAction<{ school: SchoolType; data: Gallery[] }>
    ) {
      state[action.payload.school] = action.payload.data;
    }
  }
});

export const { setAllGalleries, setGalleriesBySchool } =
  gallerySlice.actions;
export default gallerySlice.reducer;
